import React from 'react';
import about01 from '../img/about01.jpg';
import about02 from '../img/about02.jpg';
import about03 from '../img/about03.jpg';
import wedding1 from '../img/wedding1.jpg';
import wedding2 from '../img/wedding2.jpg';
import handshake from '../img/handshake.png';
import rings from '../img/rings.png';
import ImageWrapper from '../components/ImageWrapper';
import Button from '../components/Button';
import '../index.css';
import useEmblaCarousel from 'embla-carousel-react';
import { useCallback, useEffect } from 'react';
import Testimonials from '../components/Testimonials';
import eventsGuide from '../events_guide.pdf';

function Services() {
    const [emblaRef, emblaApi] = useEmblaCarousel({
        loop: true,
        watchDrag: true,
        breakpoints: {
            '(min-width: 1100px)': { watchDrag: false },
        },
    });

    useEffect(() => {
        if (emblaApi) {
            console.log(emblaApi.slideNodes()); // Access API
        }
    }, [emblaApi]);
    const scrollPrev = useCallback(() => {
        if (emblaApi) emblaApi.scrollPrev();
    }, [emblaApi]);

    const scrollNext = useCallback(() => {
        if (emblaApi) emblaApi.scrollNext();
    }, [emblaApi]);
    return (
        <>
            <div className="w-full flex flex-col items-center justify-center h-80 bg-services bg-center bg-cover">
                <h1 className="text-6xl">Services</h1>
            </div>
            <div className="page__width relative flex flex-col lg:flex-row items-center mt-40 justify-between gap-8">
                <ImageWrapper
                    className="w-full lg:w-2/5 rounded-t-full relative"
                    src={about01}>
                    <ImageWrapper
                        className="w-56 h-56 hidden lg:block absolute -bottom-16 right-1/3 border-4"
                        src={about02}
                    />
                    <div className="absolute w-full h-full rounded-[inherit] -z-[99] bg-secondary -top-16 -right-32"></div>
                </ImageWrapper>
                <div className="w-full lg:w-2/5 flex flex-col gap-4 items-center lg:items-start">
                    <h2 className="text-3xl lg:text-5xl text-center lg:text-start text-white">
                        Social Gatherings
                    </h2>
                    <p className="text-text text-base lg:text-lg text-center lg:text-start">
                        From conferences to company parties, we create
                        professional and polished events that leave a lasting
                        impression on your guests.
                    </p>
                    <div className="flex flex-col lg:flex-row items-center gap-4">
                        <Button href="/contact">Get In Touch</Button>
                        <a
                            href="/gallery/social-gatherings"
                            className="animated_link text-brand">
                            View Gallery
                        </a>
                    </div>
                    <p className="text-sm text-text">
                        Download our{' '}
                        <a
                            href={eventsGuide}
                            target="_blank"
                            className="text-brand animated_link">
                            Event Guide
                        </a>
                    </p>
                </div>
            </div>
            <div className="page__width relative flex flex-col-reverse lg:flex-row items-center mt-40 justify-between gap-8">
                <div className="w-full lg:w-2/5 flex flex-col gap-4 items-center lg:items-start">
                    <h2 className="text-3xl lg:text-5xl text-center lg:text-start text-white">
                        Corporate Events
                    </h2>
                    <p className="text-text text-base lg:text-lg text-center lg:text-start">
                        From conferences to company parties, we create
                        professional and polished events that leave a lasting
                        impression on your guests.
                    </p>
                    <div className="flex flex-col lg:flex-row items-center gap-4">
                        <Button href="/contact">Get In Touch</Button>
                        <a
                            href="/gallery/corporate-events"
                            className="animated_link text-brand">
                            View Gallery
                        </a>
                    </div>
                    <p className="text-sm text-text">
                        Download our{' '}
                        <a
                            href={eventsGuide}
                            target="_blank"
                            className="text-brand animated_link">
                            Event Guide
                        </a>
                    </p>

                    <ImageWrapper
                        src={handshake}
                        className="absolute bottom-0 -left-24 -rotate-[6deg] w-1/5 z-50 mt-8"
                    />
                </div>
                <ImageWrapper
                    className="w-full lg:w-2/5 rounded-t-full relative"
                    src={about03}>
                    <ImageWrapper
                        className="w-48 h-48 hidden lg:block absolute -bottom-16 right-8 border-4"
                        src={about02}
                    />
                    <div className="absolute w-full h-full rounded-[inherit] -z-[99] bg-secondary -top-16 -left-32"></div>
                </ImageWrapper>
            </div>
            <div className="page__width relative flex flex-col lg:flex-row items-center mt-40 justify-between gap-8">
                <ImageWrapper
                    className="w-full lg:w-2/5 rounded-t-full relative"
                    src={wedding2}>
                    <ImageWrapper
                        className="w-56 h-56 hidden lg:block absolute -bottom-16 right-1/3 border-4"
                        src={wedding1}
                    />
                    <div className="absolute w-full h-full rounded-[inherit] -z-[99] bg-secondary -top-16 -right-32"></div>
                </ImageWrapper>
                <div className="w-full lg:w-2/5 flex flex-col gap-4 items-center lg:items-start">
                    <h2 className="text-3xl lg:text-5xl text-center lg:text-start text-white">
                        Wedding Ceremonies
                    </h2>
                    <p className="text-text text-base lg:text-lg text-center lg:text-start">
                        We'll make your wedding day magical and stress-free,
                        handling everything from the venue to the smallest
                        details, so you can just enjoy the moment.
                    </p>
                    <div className="flex flex-col lg:flex-row items-center gap-4">
                        <Button href="/contact">Get In Touch</Button>
                        <a
                            href="/gallery/wedding-ceremonies"
                            className="animated_link text-brand">
                            View Gallery
                        </a>
                    </div>
                    <p className="text-sm text-text">
                        Download our{' '}
                        <a
                            href={eventsGuide}
                            target="_blank"
                            className="text-brand animated_link">
                            Event Guide
                        </a>
                    </p>
                    <ImageWrapper
                        src={rings}
                        className="absolute bottom-24 -right-40 rotate-[11deg] w-1/5 z-50 mt-8"
                    />
                </div>
            </div>
            <div className="relative bg-secondary py-16 mt-20 flex flex-col items-center justify-between">
                <Testimonials />
            </div>
        </>
    );
}

export default Services;
